import { render, staticRenderFns } from "./SignAndSend.vue?vue&type=template&id=b4f2444e&scoped=true&"
import script from "./SignAndSend.vue?vue&type=script&lang=js&"
export * from "./SignAndSend.vue?vue&type=script&lang=js&"
import style0 from "./SignAndSend.vue?vue&type=style&index=0&id=b4f2444e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4f2444e",
  null
  
)

export default component.exports